import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from '@chakra-ui/react';
import { Typography } from '@sgi/gravity';
export function NotFound() {
    return (_jsxs(Flex, { flexDirection: 'column', alignItems: 'center', paddingTop: '400px', flex: 1, gap: 10, children: [_jsx(Typography, { fontSize: 108, children: "404" }), _jsx(Typography, { fontSize: 46, children: "Good grief! Now What?" })] }));
}
